import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';


@Component({
    selector: 'app-bulk-resume-upload-model',
    templateUrl: './bulk-resume-upload-model.component.html',
    styleUrls: ['./bulk-resume-upload-model.component.scss'],
    standalone: false
})
export class BulkUploadResumeModelComponent implements OnInit {


  @Output() event = new EventEmitter<any>();
  @Input() id: string;


  fileInfoList: any = [];
  fileList: any = [];
  validFileType = ['doc', 'docx', 'pdf', 'txt', 'odt', 'Doc', 'Docx', 'Pdf', 'Txt', 'Odt'];
  resumeStatus: String = 'upload';
  idx = 0;

  totalFilesSucessfullyUploaded: number = 0;
  totalunsuccessfullFilesUploaded: number = 0;
  totalDuplicateFileUploaded: number = 0;

  totalFilesUploaded: number = 0;

  showMaxFileError: boolean = false;
  showEvaluationCriteriaLoader: boolean = false;
  hideSuggestions: boolean = false;
  removedCriteriaOnEdit = [];
  showEvaluation: boolean = true;
  showInfoIcon: boolean = false;

  uploadedFileUrls: string[] = [];
  criteriaFetched = false;
  maxFileErrorMessage: string = '';
  criteriaError: boolean = false;

  bulkSpinnerLoader: boolean = false;
  addBulkCandidateArray: any[] = [];


  constructor(
    private atsResumeScreenService: AtsResumeScreenService,
    private activeModelService: NgbActiveModal
  ) { }

  ngOnInit() {

  }

  onDrop(event: CdkDragDrop<string[]>) {
    // const keys = this.formLength();
    // moveItemInArray(keys, event.previousIndex, event.currentIndex);
    // const reorderedForm: any = {};
    // keys.forEach(key => {
    //   reorderedForm[key] = this.aiScreeningCriteriaForm.get(key);
    // });
    // this.aiScreeningCriteriaForm = this.fb.group(reorderedForm);
  }

  uploadResume(event: any) {
    let newFiles = [];
    newFiles = Array.from(event.target.files);
    let filteredNewFiles = [];
    // Filter duplicates
    filteredNewFiles = newFiles.filter(newFile => {
      return !this.fileList.some(existingFile =>
        existingFile.name === newFile.name && existingFile.size === newFile.size
      );
    });

    if (filteredNewFiles.length === 0) {
      return;
    }

    // If total > 10 â†’ show error and stop
    if (this.fileList.length + filteredNewFiles.length > 10) {
      this.showMaxFileError = true;
      this.maxFileErrorMessage = 'You can upload a maximum of 10 resumes';
      return;
    }

    this.showMaxFileError = false;
    this.maxFileErrorMessage = '';

    // Merge files
    this.fileList = [...this.fileList, ...filteredNewFiles];

    let keyCount = this.fileInfoList.length
    let fileType = '';
    filteredNewFiles.forEach(item => {
      if (item && item.name) {
        fileType = item.name.split('.').pop();
        // fileType = item.name.slice(item.name.lastIndexOf('.'));
        if (fileType && this.validFileType.includes(fileType)) {
          if (item.size) {
            let sizeinmb = item.size / Math.pow(10, 6); // MB
            if (sizeinmb > 5) {
              this.fileInfoList.push({
                key: keyCount,
                filename: item.name,
                message: 'File size more than 5MB',
                status: 'fail',
                candidatename: ''
              });
            } else {
              this.fileInfoList.push({
                key: keyCount,
                filename: item.name,
                message: '',
                status: 'load',
                candidatename: ''
              });
            }
          }
        } else {
          this.fileInfoList.push({
            key: keyCount,
            filename: item.name,
            message: 'Unsupported file type',
            status: 'fail',
            candidatename: ''
          });
        }
      }
      item['key'] = keyCount;
      keyCount++;
    });

    this.resumeStatus = 'ongoing';
    this.parseResume(filteredNewFiles);

  }



  parseResume(data: any[]) {
    data.forEach((file) => {
      if (this.fileInfoList[file.key]?.status === 'load') {
        this.atsResumeScreenService.resumeScreeningUploadResume(file, this.id).subscribe((resp: any) => {
          this.totalFilesUploaded++;
          if (resp?.body?.status === "success") {

            if (resp?.body?.data?.importstatus == 'successful' || resp?.body?.data?.importstatus == 'success') {
              this.addBulkCandidateArray.push(resp?.body?.data);
              this.totalFilesSucessfullyUploaded++;
              this.fileInfoList[file.key].status = 'success';
              this.fileInfoList[file.key].message = 'Successfully Uploaded';

            } else if (resp?.body?.data?.importstatus == 'duplicate') {
              this.totalDuplicateFileUploaded++;
              this.fileInfoList[file.key].status = 'duplicate';
              this.fileInfoList[file.key].message = 'Duplicate Profile';

            } else if (resp?.body?.data?.importstatus == 'unsuccessful') {
              this.totalunsuccessfullFilesUploaded++;
              this.fileInfoList[file.key].status = 'unsuccessful';
              this.fileInfoList[file.key].message = 'Upload Failed';

            } else if (resp?.body?.data?.importstatus == 'word-limit-exceeded') {
              this.totalunsuccessfullFilesUploaded++;
              this.fileInfoList[file.key].status = 'word-limit-exceeded';
              this.fileInfoList[file.key].message = 'Resume exceeds the 2,000 word limit';
            } else if (resp?.body?.data?.importstatus == 'size-too-large') {
              this.totalunsuccessfullFilesUploaded++;
              this.fileInfoList[file.key].status = 'size-too-large';
              this.fileInfoList[file.key].message = 'Size Too Large';

            } else {
              this.totalunsuccessfullFilesUploaded++;
              this.fileInfoList[file.key].status = 'unsuccessful';
              this.fileInfoList[file.key].message = 'Upload Failed';
            }

          } else {
            this.totalunsuccessfullFilesUploaded++
            this.fileInfoList[file.key].status = 'unsuccessful';
            this.fileInfoList[file.key].message = "Upload Failed";
          }


          if (this.fileList.length >= 10) {
            this.resumeStatus = 'ongoing';
          } else {
            // this.resumeStatus = 'upload';
          }
        }, (error) => {

          if (error?.error?.data?.importstatus == 'size-too-large') {
            this.totalFilesUploaded++;
            this.totalunsuccessfullFilesUploaded++;
            this.fileInfoList[file.key].status = 'size-too-large';
            this.fileInfoList[file.key].message = 'Size Too Large';
          } else if (error?.error?.data?.importstatus == 'word-limit-exceeded') {
            this.totalFilesUploaded++;
            this.totalunsuccessfullFilesUploaded++;
            this.fileInfoList[file.key].status = 'word-limit-exceeded';
            this.fileInfoList[file.key].message = 'Resume exceeds the 2,000 word limit';
          } else {
            this.totalFilesUploaded++;
            this.totalunsuccessfullFilesUploaded++;
            this.fileInfoList[file.key].status = 'unsuccessful';
            this.fileInfoList[file.key].message = 'Upload Failed';
          }
          
          if (this.fileList.length >= 10) {
            this.resumeStatus = 'ongoing';
          } else {
            // this.resumeStatus = 'upload';
          }
        });
      } else {
        this.totalFilesUploaded++;
        if (this.fileList.length >= 10) {
          this.resumeStatus = 'ongoing';
        } else {
          this.resumeStatus = 'upload';
        }
      }
    });
  }


  deleteResume(file: any) {
    this.fileList = this.fileList.filter((f: any) => f.key !== file.key);
    this.fileInfoList = this.fileInfoList.filter((f: any) => f.key !== file.key);
    if (file.status === 'success') {
      this.uploadedFileUrls = this.uploadedFileUrls.filter(url => url !== file.url);
      this.addBulkCandidateArray = this.addBulkCandidateArray.filter(res => res.filename !== file.filename);
      this.totalFilesSucessfullyUploaded--;
    }

    this.totalFilesUploaded = this.fileInfoList.filter((f: any) => f.status === 'success' || f.status === 'unsuccessful').length;

  };


  addBulkResume() {
    if (!this.addBulkCandidateArray?.length) return;
    const data = {
      candidates: this.addBulkCandidateArray,
      talentpoolnumber: this.id
    }
    this.bulkSpinnerLoader = true;
    this.atsResumeScreenService.createBulkCandidate(data, this.id).subscribe((res: any) => {
      if (res && res.body && res?.body?.status == 'success') {
        this.event.emit({ status: 'success', message: 'created' });
        this.activeModelService.close();
      } else {
        this.event.emit({ status: 'error', message: 'failed' });
        this.activeModelService.close();
      };
      this.bulkSpinnerLoader = false;
    }, (error) => {
      this.event.emit({ status: 'error', message: 'failed' });
      this.activeModelService.close();
      this.bulkSpinnerLoader = false;
    });
  };


  dismiss(type: string = '') {
    if (type?.trim()) this.event.emit({ status: 'cancel', message: 'cancel' });
    this.activeModelService.close();
    this.addBulkCandidateArray = [];
  };

}